import React, { useEffect, useState } from "react";
import { Container, FormGroup, Label } from 'reactstrap';
import Swal from "sweetalert2";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Loading } from "../share/loading";
import TextErrors from "../share/TextErrors";
import InputField from "../share/InputField";
export const ChangePasswordComponent = () => {

    const user = JSON.parse(localStorage.getItem("userData"))
    const [oldPassword, setOldPassword] = useState("");
    // console.log("oldPassword")
    // console.log(oldPassword)
    const registerId = user.registerId;
    const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z\d]{8,}$/;
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        GetOldPassword();
    }, [])

    const GetOldPassword = async () => {
        setLoading(true);
        try {
            const res = await fetch(`api/Users/getOldPasswordRegis?registerId=${registerId}`)
            const resJson = await res.json();
            setOldPassword(resJson.dataenum)
        } catch (err) {
            // console.log("err =>", err)
        } finally {
            setLoading(false);
        }
    }

    const formInitialValues = {
        registerId: registerId,
        password: "",
        cPassword: ""
    };

    const validateSchema = Yup.object().shape({
        password: Yup.string()
            .matches(passwordRegex, 'รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร ประกอบด้วย ตัวเลข ตัวอักษรตัวใหญ่ และตัวอักษรตัวเล็ก')
            .required("โปรดระบุรหัสผ่าน"),
        cPassword: Yup.string()
            .oneOf([Yup.ref('password'), null], 'รหัสผ่านไม่ตรงกัน')
            .required('กรุณายืนยันรหัสผ่าน'),
    });

    const onSubmit = async (values, action) => {
        // console.log("test", values)
        Swal.fire({
            icon: "info",
            title: "ยืนยันการเปลี่ยนรหัสผ่านหรือไม่?",
            text: "",
            confirmButtonColor: "#0A66C2",
            confirmButtonText: "ตกลง",
            showCancelButton: true,
            cancelButtonText: "ยกเลิก",
            cancelButtonColor: "#ff0000",
        }).then(async (result) => {
            if (result.isConfirmed) {
                if (values.password === oldPassword.password) {
                    Swal.fire({
                        icon: "warning",
                        title: "",
                        text: "กรุณาใช้รหัสผ่านใหม่ เนื่องจากใช้รหัสผ่านเดิม",
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                    })
                } else {
                    const res = await fetch(`api/Users/changePassword`, {
                        method: "POST",
                        headers: { 'Content-type': 'application/json' },
                        body: JSON.stringify(values)
                    })
                    const resJson = await res.json();
                    if (resJson.status === 1) {
                        Swal.fire({
                            icon: "success",
                            title: "เปลี่ยนรหัสผ่านสำเร็จ",
                            text: "",
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                            timer: 2000
                        }).then(async (result) => {
                            GetOldPassword()
                            window.location.reload();
                        });
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "เปลี่ยนรหัสผ่านไม่สำเร็จ",
                            text: "มีบางอย่างผิดปกติ",
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                            timer: 2000
                        })
                    }
                }


            }
        })

    };
    if (loading) { return <Loading /> }
    return (
        <Formik
            initialValues={formInitialValues}
            validationSchema={validateSchema}
            onSubmit={onSubmit}
            enableReinitialize
        >
            {() => (
                <Container className="form-border p-5">
                    <Form className="px-5 mx-5">
                        <FormGroup row>
                            <Label sm={12}>
                                รหัสผ่าน:
                                <ErrorMessage name="password" component={TextErrors} />
                            </Label>
                            <Field sm={12} name={"password"} type="password" component={InputField} />
                        </FormGroup>
                        <FormGroup row>
                            <Label sm={12}>
                                ยืนยันรหัสผ่าน:
                                <ErrorMessage name="cPassword" component={TextErrors} />
                            </Label>
                            <Field sm={12} name={"cPassword"} type="password" component={InputField} />
                        </FormGroup>

                        <div className="d-flex justify-content-center mt-3">
                            <button type="submit" className="btn-blue w-25">บันทึก</button>
                        </div>
                    </Form>


                </Container>
            )}
        </Formik>
    )
}
